import { useEffect } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { playQuack, markQuacked } from "../lib/quack";
import { devWarn } from "../lib/log";

// "rendering" = the front render is running in a background job (POST /creations answers 202 immediately).
export const BUILDING = ["rendering", "queued", "building", "waiting", "views", "views_review"];

// Polls the current creation every 3 s while its 3D build is in progress.
export const useBuildPolling = (current, setCurrent, loadGallery) => {
  const buildingId = current && BUILDING.includes(current.build_status) ? current.id : null;

  useEffect(() => {
    if (!buildingId) return undefined;
    // Don't quack for a state the duck is ALREADY in when polling starts (page reload / re-open) — only live
    // transitions should quack. Seed those events as already-handled.
    if (current?.build_status === "views_review") markQuacked(`${buildingId}:views`);
    if (current?.render && current?.status === "preview") markQuacked(`${buildingId}:render`);
    const t = setInterval(async () => {
      try {
        const { data } = await api.get(`/creations/${buildingId}`);
        setCurrent((c) => (c && c.id === data.id ? { ...c, ...data, photo: c.photo || data.photo } : c));
        // Step 02 — the AI side/face views are ready for the user to review (poll keeps running; quack once).
        if (data.build_status === "views_review") playQuack("views", { once: `${data.id}:views` });
        if (BUILDING.includes(data.build_status)) return;
        loadGallery();
        if (data.render && data.status === "preview") {
          playQuack("render", { once: `${data.id}:render` }); // Step 02 — the AI front render just landed
          return; // stay on the approval step
        }
        if (data.build_status === "ready") {
          playQuack("ready", { once: `${data.id}:ready` }); // Step 03 — built & downloads available
          toast.success("Quack! Your 3D figurine is ready to print!");
        } else if (data.build_status !== "cancelled") toast.error(data.build_error || "3D build failed."); // no sound on failure
      } catch (e) {
        devWarn("Build poll failed, retrying", e?.message);
      }
    }, 3000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buildingId, setCurrent, loadGallery]);
};
